const isLocal = process.env.NODE_ENV === 'development'

const config =  {
    apiGatewayGuest: {
        REGION: 'eu-west-1',
        URL: isLocal ? 'https://ah7cxw1aa6.execute-api.eu-west-1.amazonaws.com/dev/' : 'https://c9rtj2s6a4.execute-api.eu-west-1.amazonaws.com/prod/',
        PATH: 'guest-api',
    },
    apiGatewayProvider: {
        REGION: 'eu-west-1',
        URL: isLocal ? 'https://w7ozevkp8i.execute-api.eu-west-1.amazonaws.com/dev/' : 'https://vo8ph9hbi9.execute-api.eu-west-1.amazonaws.com/prod/',
        PATH: 'provider-api',
    },
    cognito: {
        REGION: 'eu-west-1',
        USER_POOL_ID: 'eu-west-1_9BhjYaSo9',
        APP_CLIENT_ID: '3h5ak9enuqgfkppe26vbecr7t',
        IDENTITY_POOL_ID: 'eu-west-1:bc4e6854-83dd-4e28-97ba-5accd55d2e2f'
    },
    s3: {
        REGION: 'eu-west-1',
        BUCKET: 'ee-providers-user-upload'
    },
    SENTRY_DSN: 'https://c50418b49892f34bbcdd37a9d8272d01@o290751.ingest.us.sentry.io/4511261977018368',
    stripeKey: isLocal ? 'pk_test_plzSpBxLrRhZw6wLlnhCrJfY' : 'pk_live_fIoidmljhP24yGlK0RhbcQnT',
    stripeReturnUrl: isLocal ? 'http://localhost:3000' : 'https://app.energyefficiency.ie/billing'
}
export default config